import * as types from "../types/index";
import { core } from "./core";

export const getTags = (queryString) => {
  return core.API(
    "GET",
    `/tags?${queryString}`,
    types.GET_PROJECT_TAGS,
    types.GET_PROJECT_TAGS_SUCCESS,
    types.GET_PROJECT_TAGS_FAILURE
  );
};

export const createTag = (data) => {
  return core.API(
    "POST",
    `/tag`,
    types.CREATE_PROJECT_TAG,
    types.CREATE_PROJECT_TAG_SUCCESS,
    types.CREATE_PROJECT_TAG_FAILURE,
    data
  );
};

export const deleteTag = (id) => {
  return core.API(
    "DELETE",
    `/tag/${id}`,
    types.DELETE_PROJECT_TAG,
    types.DELETE_PROJECT_TAG_SUCCESS,
    types.DELETE_PROJECT_TAG_FAILURE
  );
};

export const updateTag = (id, data) => {
  return core.API(
    "PUT",
    `/tag/${id}/`,
    types.PUT_PROJECT_TAG,
    types.PUT_PROJECT_TAG_SUCCESS,
    types.PUT_PROJECT_TAG_FAILURE,
    data
  );
};

export const getTagMatches = (queryString) => {
  return core.API(
    "GET",
    `/tag/matches?${queryString}`,
    types.GET_PROJECT_TAG_MATCHES,
    types.GET_PROJECT_TAG_MATCHES_SUCCESS,
    types.GET_PROJECT_TAG_MATCHES_FAILURE
  );
};
